import { notification, Modal } from "antd";
import { ApolloError } from "apollo-client";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { VolunteersStore } from "./VolunteersStore";
import moment from "moment";

const mapCommunities = (list: any[] = []) => {
  return list.map((n) => ({
    title: n.name,
    key: n.id,
    value: n.id,
    children: [],
  }));
};

const mapDivisions = (list: any[] = []) => {
  return list.map((n) => {
    const children = mapCommunities(n.communities);
    return {
      title: n.name,
      key: n.id,
      value: n.id,
      children,
      disabled: children.length === 0,
    };
  });
};

const getTree = (regions: any[] = []) => {
  return regions.map((n) => {
    const children = mapDivisions(n.divisions);
    return {
      title: n.name,
      key: n.id,
      value: n.id,
      children,
      disabled: children.filter((x) => !x.disabled).length === 0,
    };
  });
};

export class VolunteerEditStore {
  store: VolunteersStore;
  showDlg = false;
  loading = false;
  saving = false;
  id;
  model: any;

  flexible = false;
  mode: "Dates" | "Deadline" = "Dates";
  fileList: any[] = [];

  regionTree: any[] = [];

  uploading = false;

  constructor(store: VolunteersStore) {
    makeAutoObservable(this, {
      store: false,
    });
    this.store = store;
  }

  @action loadRegions() {
    Api.me.regionsTree().then((res) => {
      runInAction(() => {
        this.regionTree = getTree(res.data.regions);
        console.log("region tree", this.regionTree);
      });
    });
  }

  findCommunities(ids: string[] = []) {
    let list: any[] = [];
    this.regionTree.forEach((r) => {
      r.children.forEach((d) => {
        d.children.forEach((c: any) => {
          if (ids.includes(c.key)) {
            list.push({ id: c.key, name: c.title });
          }
        });
      });
    });
    return list;
  }

  @action
  edit(id) {
    this.id = id;
    this.model = null;
    this.reload();
    this.showDlg = true;
  }

  @action
  duplicate(id) {
    this.id = id;
    this.model = null;
    this.reload(true);
    this.showDlg = true;
  }

  @action show(model?) {
    this.model = model;
    this.fileList = [];
    this.flexible = false;
    this.showDlg = true;
  }
  @action close() {
    this.showDlg = false;
  }
  @action setFlexible(val) {
    this.flexible = val;
  }
  @action setFileList(val) {
    this.fileList = val;
  }
  @action reload(duplicate: boolean = false) {
    this.loading = true;
    Api.volunteer
      .volunteer(this.id)
      .then((res) => {
        runInAction(() => {
          const {
            id,
            version,
            schedule = [],
            options = [],
            deadline,
            maxHours,
            location,
            requirements,
            recipients,
            questions,
            manager,
            ...other
          } = res.data.volunteer;
          const location_ = location?.placeId
            ? { key: location.placeId, value: location.placeId, label: location.addr }
            : null;
          this.mode = res.data.volunteer.deadline && res.data.volunteer.maxHours ? "Deadline" : "Dates";
          this.model = {
            ...other,
            options: options || [{}],
            id: duplicate ? undefined : id,
            version: duplicate ? undefined : version,
            schedule: duplicate ? [] : schedule || [],
            maxHours,
            deadline: !duplicate && this.mode == "Deadline" ? moment(deadline) : null,
            manager: manager || [],
            requirement: requirements,
            questions: (questions || []).length === 0 ? [""] : questions,
            location: location_,
            displayAddress: location?.displayAddress,
            communityIds: recipients.community.map((x) => x.id),
          };
          this.flexible = other.customizedChoice;
          if (other.pic) {
            this.fileList = [
              {
                imageWidth: other.pic.imageWidth,
                imageHeight: other.pic.imageHeight,
                imageSize: other.pic.imageSize,
                path: other.pic.imageUrl,
                url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${other.pic.imageUrl}`,
              },
            ];
          } else {
            this.fileList = [];
          }
        });
      })
      .finally(() => (this.loading = false));
  }

  @action save(values) {
    console.log("save values", values);

    // return

    const { communityIds, displayAddress, schedule, options, deadline, maxHours, ...other } = values;

    let location: any = values.location
      ? {
          placeId: values.location.key,
          addr: values.location.label,
          displayAddress,
        }
      : null;

    const recipients = {
      community: this.findCommunities(communityIds),
    };

    const more: any =
      this.mode == "Dates" ? { schedule, options } : { deadline: moment(deadline).format("YYYY-MM-DD"), maxHours };
    this.saving = true;
    Api.volunteer
      .createVolunteer({
        id: this.model?.id,
        version: this.model?.version,
        ...other,
        recipients,
        location,
        ...more,
      })
      .then((res) => {
        console.log("res", res);
        const { code, msg } = res.data.createVolunteer;
        if (!code) {
          notification.success({ message: "Success!" });
          setTimeout(() => {
            this.store.refresh();
          }, 3000);
          this.showDlg = false;
          return;
        }

        if (code === "Volunteer.Activity.Edit.ScheduleChanged") {
          Modal.confirm({
            content: msg,
            cancelText: "Let me think",
            okText: "Confirm",
            onOk: () => {
              return Api.volunteer
                .createVolunteer({
                  id: this.model?.id,
                  version: this.model?.version,
                  ...other,
                  recipients,
                  location,
                  confirm: true,
                })
                .then((res) => {
                  notification.success({ message: "Success!" });
                  setTimeout(() => {
                    this.store.refresh();
                  }, 3000);
                  this.showDlg = false;
                });
            },
          });
        } else {
          notification.error({
            message: msg,
          });
        }
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }
}
